import { Col, Row } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { Link } from 'src/components/Link/Link';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { LoanApplicationDto } from 'src/generated-api-client';
import { UserStore } from 'src/stores/UserStore/UserStore';

type LoanApplicationGeneralInfoProps = {
    application?: LoanApplicationDto;
};

export const LoanApplicationGeneralInfo = observer(
    ({ application }: LoanApplicationGeneralInfoProps) => {
        return (
            <Card title={t('LoanApplication.GeneralInfo.Title')}>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.GeneralInfo.ApplicationID',
                            )}
                            value={application?.number}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('LoanApplication.GeneralInfo.CreatedAt')}
                            value={application?.createdAt}
                            formatValue="dateTimeSeconds"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('LoanApplication.GeneralInfo.PhoneNumber')}
                            value={application?.phoneNumber}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('LoanApplication.GeneralInfo.SecretKey')}
                            value={application?.secretKey}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('LoanApplication.GeneralInfo.Merchant')}
                            value={application?.merchant}
                            formatValue={(merchant) =>
                                // Only roles that can view the merchant entity
                                // (CreditOfficer) get a navigable link into the
                                // merchant card; others see the number as text.
                                UserStore.can.view.merchants ? (
                                    <Link
                                        to={EntityLinks.merchants.itemDetails?.(
                                            merchant.id,
                                        )}
                                    >
                                        {merchant.number}
                                    </Link>
                                ) : (
                                    merchant.number
                                )
                            }
                        />
                    </Col>
                </Row>
            </Card>
        );
    },
);
